<template>
  <div id="myAvailability">
    <el-card
      shadow="hover"
      class="mainCard clear-card"
    >
      <div class="header">
        <div class="title defaultCursor">
          {{ $t('coach.myAvailability.title') }}
        </div>
        <div class="action">
          <el-button
            type="text"
            @click="$emit('update:show', !show)"
          >
            {{ show ? $t('common.hide') : $t('common.view') }}
          </el-button>
        </div>
      </div>

      <el-collapse-transition>
        <div
          v-if="show"
          class="content"
        >
          <div style="margin: 10px 5px 20px;">
            {{ $t('coach.myAvailability.desc') }}
          </div>

          <el-row
            :gutter="15"
            type="flex"
          >
            <el-col
              :span="responsiveRow.one"
              class="left"
            >
              <div class="mobileModeWrap">
                <el-button
                  v-if="['mobile', 'tablet'].includes($mq) && view === 'recurring'"
                  class="saveBtn mobileMode"
                  type="primary"
                  round
                  :disabled="!canSaveRecurring"
                  @click="saveAvailabilities"
                >
                  {{ $t('common.save') }}
                </el-button>

                <el-button
                  v-if="['mobile', 'tablet'].includes($mq) && view !== 'recurring'"
                  type="primary"
                  round
                  class="saveException saveBtn mobileMode"
                  :disabled="!canSaveExceptions"
                  @click="saveExceptions"
                >
                  {{ $t('common.save') }}
                </el-button>
              </div>

              <div
                class="functionalWrap"
                :class="`${$mq}Mode`"
              >
                <div>
                  <div>
                    <el-button
                      :type="view === 'recurring' ? 'none' : 'primary'"
                      round
                      @click="switchView('recurring')"
                    >
                      {{ $t('coach.myAvailability.recurring') }}
                    </el-button>
                  </div>

                  <div>
                    <el-button
                      :type="view === 'single' ? 'none' : 'primary'"
                      round
                      @click="switchView('single')"
                    >
                      {{ $t('coach.myAvailability.oneTime') }}
                    </el-button>
                  </div>

                  <div v-if="view === 'single' && ($mq === 'laptop' || $mq === 'desktop') ">
                    <MiniSingleAvailabilityWidget
                      class="miniCalendar"
                      :single-availability-period="singleAvailabilityPeriod"
                    />
                  </div>
                </div>

                <div v-if="!isRootPlatform">
                  <el-button
                    class="clearBtn"
                    type="plain"
                    round
                    :loading="importLoading"
                    @click="importCalendar"
                  >
                    {{ $t('coach.myAvailability.importCalAvail') }}
                  </el-button>
                </div>
              </div>
            </el-col>
            <el-col
              :span="responsiveRow.two"
              class="right"
            >
              <div v-if="view === 'recurring'">
                <el-button
                  v-if="['desktop', 'laptop'].includes($mq)"
                  class="saveBtn"
                  type="primary"
                  round
                  :disabled="!canSaveRecurring"
                  @click="saveAvailabilities"
                >
                  {{ $t('common.save') }}
                </el-button>

                <AvailabilityWidget
                  v-loading="loadArr.length"
                  :recurring-availabilities.sync="recurringAvailabilities"
                  :last-id.sync="id"
                  :can-save-recurring.sync="canSaveRecurring"
                />
              </div>
              <div v-else>
                <el-button
                  v-if="['desktop', 'laptop'].includes($mq)"
                  type="primary"
                  round
                  class="saveException saveBtn"
                  :disabled="!canSaveExceptions"
                  @click="saveExceptions"
                >
                  {{ $t('common.save') }}
                </el-button>

                <SingleAvailabilityWidget
                  v-loading="loadArr.length"
                  :recurring-availabilities="recurringAvailabilities"
                  :exception-availabilities.sync="exceptionAvailabilities"
                  :last-id="id"
                  :single-availability-period.sync="singleAvailabilityPeriod"
                  :can-save-exceptions.sync="canSaveExceptions"
                  :is-loading-exceptions="isLoadingExceptions"
                />
              </div>
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>
    </el-card>
  </div>
</template>

<script>
import api from '@/api';
import AvailabilityWidget from './fullCalendar/AvailabilityWidget.vue';
import SingleAvailabilityWidget from './fullCalendar/SingleAvailabilityWidget.vue';
import MiniSingleAvailabilityWidget from './fullCalendar/MiniSingleAvailabilityWidget.vue';

export default {
  components: {
    AvailabilityWidget,
    SingleAvailabilityWidget,
    MiniSingleAvailabilityWidget,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // show: true,
      view: 'recurring',
      // view: 'single',
      recurringAvailabilities: [],
      recurringAvailabilitiesBackUp: [],
      id: 0,
      exceptionAvailabilities: [],
      singleAvailabilityPeriod: null,
      canSaveExceptions: false,
      canSaveRecurring: false,
      loadArr: [],
      isLoadingExceptions: false,
      importLoading: false,
    };
  },

  computed: {
    responsiveRow() {
      const col = {};
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 24;
        col.two = 24;
      } else if (this.$mq === 'laptop') {
        col.one = 8;
        col.two = 16;
      } else {
        col.one = 6;
        col.two = 18;
      }
      return col;
    },

    responsiveCol() {
      let col = 24;
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col = 24;
      }
      return col;
    },

    isRootPlatform() {
      let flag = false;
      if (process.env.VUE_APP_SERVICE === 'gcg_platform') { flag = true; }
      return flag;
    },
  },

  watch: {
    singleAvailabilityPeriod({ start, end }) {
      const formattedStart = this.$moment(start).format('YYYY-MM-DD');
      const formattedEnd = this.$moment(end).format('YYYY-MM-DD');

      this.getExceptions(formattedStart, formattedEnd);
    },
  },

  created() {
    this.getRecurring();
    // this.getExceptions();
  },

  methods: {
    switchView(view) {
      this.view = view;
      this.canSaveExceptions = false;
      this.canSaveRecurring = false;

      if (view === 'single') {
        // deep copy
        this.recurringAvailabilities = this.recurringAvailabilitiesBackUp.map((a) => ({ ...a }));
      }
    },

    async getRecurring() {
      try {
        this.loadingHandler('add');
        const response = await api.getCoachRecurringAvailabilities();
        this.recurringAvailabilities = [];
        this.formatRecurringAvailabilities(response.data);
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loadingHandler('pop');
      }
    },

    async getExceptions(start, end) {
      try {
        this.loadingHandler('add');
        this.isLoadingExceptions = true;
        const response = await api.getCoachCalendarExceptions({
          start_date: start,
          end_date: end,
        });
        // console.log(response);
        this.exceptionAvailabilities = null;
        this.formatExceptionsAvailabilities(response.data);
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loadingHandler('pop');
        this.isLoadingExceptions = false;
      }
    },

    formatExceptionsAvailabilities(exceptions) {
      const formattedExceptions = exceptions.map((el) => {
        const exception = el;
        exception.day = this.$moment(el.date).format('dddd').toLowerCase();
        exception.hours = exception.hours.sort();
        return exception;
      });
      this.exceptionAvailabilities = formattedExceptions;
    },

    formatRecurringAvailabilities(availabilities) {
      Object.keys(availabilities).forEach((day) => {
        availabilities[day].forEach((time) => {
          const lastEvent = this.recurringAvailabilities[this.recurringAvailabilities.length - 1];

          // check if it s same day as last event
          // if it s same and the event start when previous end,
          // we add 30 minutes to duration of previous event
          if (lastEvent && lastEvent.saveDay === day) {
            // console.log('same day');

            const [durationHours, durationMinutes] = lastEvent.duration.split(':');
            const lastEventEnd = this.$moment(`2012-01-01 ${lastEvent.saveTime}`)
              .add(durationHours, 'hours')
              .add(durationMinutes, 'minutes');
            const newEvent = this.$moment(`2012-01-01 ${time}`);

            if (lastEventEnd.isSame(newEvent)) {
              const newDuration = this.$moment.duration(lastEvent.duration)
                .add(30, 'minutes');
              lastEvent.duration = `${Math.floor(newDuration.asHours())}:${newDuration.minutes().toString().padStart(2, '0')}`;
            } else {
              this.addEventToList(day, time);
            }
          } else {
            this.addEventToList(day, time);
          }
        });
      });
      // deep copy
      this.recurringAvailabilitiesBackUp = this.recurringAvailabilities.map((a) => ({ ...a }));
    },

    convertDayToRRule(day, time) {
      let BYDAY;

      // `DTSTART:20120201T090000
      // RRULE:FREQ=WEEKLY;INTERVAL=1;BYDAY=MO`,
      switch (day) {
        case 'monday':
          BYDAY = 'MO';
          break;
        case 'tuesday':
          BYDAY = 'TU';
          break;
        case 'wednesday':
          BYDAY = 'WE';
          break;
        case 'thursday':
          BYDAY = 'TH';
          break;
        case 'friday':
          BYDAY = 'FR';
          break;
        case 'saturday':
          BYDAY = 'SA';
          break;
        case 'sunday':
          BYDAY = 'SU';
          break;
        default:
          BYDAY = '';
      }

      if (!BYDAY) return '';
      return `DTSTART:20120101T${time.replace(':', '')}00
RRULE:FREQ=WEEKLY;INTERVAL=1;BYDAY=${BYDAY}`;
    },

    addEventToList(day, time) {
      this.recurringAvailabilities.push({
        id: this.id,
        allDay: false,
        editable: true,
        backgroundColor: 'green',
        borderColor: 'green',
        saveDay: day,
        saveTime: time,
        rrule: this.convertDayToRRule(day, time),
        duration: '00:30',
      });
      this.id += 1;
    },

    async saveAvailabilities() {
      const data = {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      };

      // Format data
      this.recurringAvailabilities.forEach((el) => {
        const eventStart = this.$moment(`2012-01-01 ${el.saveTime}`);
        const [durationHours, durationMinutes] = el.duration.split(':');
        const eventEnd = this.$moment(`2012-01-01 ${el.saveTime}`)
          .add(durationHours, 'hours')
          .add(durationMinutes, 'minutes');

        do {
          data[el.saveDay].push(eventStart.format('HH:mm'));
          eventStart.add(30, 'minutes');
        } while (eventStart.isBefore(eventEnd));
      });

      // Save data
      try {
        this.loadingHandler('add');
        const response = await api.saveCoachRecurringAvailabilities(data);
        this.recurringAvailabilities = [];
        this.formatRecurringAvailabilities(response.data);
        this.canSaveRecurring = false;
      } catch (err) {
        console.log(err);
        this.canSaveRecurring = false;
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loadingHandler('pop');
      }
    },

    async saveExceptions() {
      const today = this.$moment().endOf('day').format('YYYY-MM-DD');

      const data = this.exceptionAvailabilities.filter((el) => el.date > today).map((el) => {
        const date = el;
        delete date.day;
        date.hours = date.hours.sort();
        return date;
      });

      try {
        this.loadingHandler('add');
        await api.saveCoachCalendarException(data);
        this.formatExceptionsAvailabilities(this.exceptionAvailabilities);
        this.canSaveExceptions = false;
      } catch (err) {
        console.log(err);
        this.canSaveExceptions = false;
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loadingHandler('pop');
      }
    },

    loadingHandler(key) {
      if (key === 'add') {
        this.loadArr.push('l');
      } else {
        this.loadArr.pop();
      }
    },

    async importCalendar() {
      this.$confirm(`${this.$t('common.warning')} - ${this.$t('coach.myAvailability.importAvailDesc')}`, `${this.$t('coach.myAvailability.importAvail')}`, {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        roundButton: true,
      }).then(async () => {
        try {
          this.importLoading = true;
          await api.importCalendarAvailability();
          this.getRecurring();
          this.getExceptions();
          this.$message.success(this.$t('coach.myAvailability.importSuccess'));
        } catch (err) {
          console.log(err);
          this.$message.error(err.msg);
        } finally {
          this.importLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#myAvailability {
  .header {
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: bold;
    }

    .action {
      .el-button {
        color: var(--themeFontColor);
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  .content {
    text-align: left;
    padding-top: 20px;

    .el-row {
      align-items: stretch;
      flex-wrap: wrap;

      .left {
        .functionalWrap {
          &.desktopMode,
          &.laptopMode {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }

          .miniCalendar {
            margin-bottom: 15px;
          }
        }

        .el-button {
          width: 100%;
          margin-bottom: 15px;
        }

        .clearBtn {
          padding: 13px 4px;
          background-color: transparent;
          word-break: break-word;
          white-space: normal;
          color: white;

          &:hover {
            background: rgba(255, 255, 255, 0.1);
          }
        }

        .mobileModeWrap {
          text-align: right;
        }
      }

      .right {
        text-align: right;
      }

      .saveBtn {
        // margin-top: 15px;
        width: 150px !important;
      }

      .saveException {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
